import { render, staticRenderFns } from "./static-promo-card.vue?vue&type=template&id=b3254d70&"
import script from "./static-promo-card.vue?vue&type=script&lang=js&"
export * from "./static-promo-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports